import _ from 'lodash'
import store from '@/store'

export default {
    methods: {
        can(permission) {
            if (!store.getters.user) {
                return false
            }

            return store.getters.hasPermission(permission)
        },

        canAny(permissions) {
            if (!store.getters.user) {
                return false
            }

            if (Array.isArray(permissions)) {
                const allowed = _.filter(permissions, (permission) => store.getters.hasPermission(permission))
                return allowed.length > 0
            }

            return store.getters.hasPermission(permissions)
        },
    },
}
